import { codelists } from 'constants/codelists';
// General
export const appUser = '/application/user';
export const buildInfo = '/application/build-info';
export const codeTable = '/code-table/:storeKey';
export const configJSON = '/config.json';
export const exitPoints = '';
// User
export const user = '/user';
export const userList = '/user/list';
export const userFilters = '/user/task-filter';
export const userSellerIns = '/user/seller-numbers';
export const userNotificationSettings = '/user/notification-settings';
export const userNotificationSettingsEmail = '/user/notification-settings/email';
export const userRoles = '/user/roles';

// Organizational structure
export const orgStructureChannels = `/code-table/${codelists.campaignChannels}`;
export const orgStructureEdkChannels = `/code-table/${codelists.statisticsEdkChannels}`;
export const orgStructureRegions = '/orgstructure/region';
export const orgStructureEdkRegions = `/code-table/${codelists.statisticsEdkRegions}`;
export const orgStructureAgencies = '/orgstructure/agency';
export const orgStructureManagers = '/orgstructure/manager';
export const orgStructureSellers = '/orgstructure/seller';
export const orgStructurePPZ = '/orgstructure/ppz';

// Tasks
export const task = '/task';
export const taskList = '/task/list'; // !also TaskTypeDetail
export const taskOverview = '/task/overview';
export const taskRedirect = '/task/redirect';
export const taskDetail = '/task/:id';
export const taskHistory = '/task/:id/history';
export const taskAttachment = '/task/:id/attachment';
export const taskAttachmentById = '/task/:id/attachment/:attachmentId';
export const taskNote = '/task/:id/note';
export const taskTake = '/task/:id/take';
export const taskFinish = '/task/:id/finish';
export const taskOpen = '/task/:id/open';
export const taskUnread = '/task/:id/unread';
export const taskStatistics = '/task/statistics-summary';
export const taskStatisticsExport = '/task/statistics-summary-export';
export const taskEmailCopy = '/task/email-copy';
export const taskTypes = `/code-table/${codelists.taskTypes}`;
export const taskPolicyPartnerList = '/task/:id/policy-partner-list';
export const prospector = '/prospector/:nationalIn';
// Campaigns
export const campaign = '/campaign';
export const campaignAdditionalData = '/campaign/:id/additional-data';
export const campaignDetail = '/campaign/:id';
export const campaignDetailWithoutConsideringRole = '/campaign/:id/settings'; // campaignDetail for campaign settings pages + nominations
export const campaignDeleteContacts = '/campaign/:id/delete-contacts';
export const campaignList = '/campaign/list';
export const campaignListSettings = '/campaign/list-campaign-setting';
export const campaignGuarantorRegion = '/campaign/:id/guarantor/region';
export const campaignGuarantorCandidate = '/campaign/guarantor/candidate';
export const campaignGuarantorActiveAllRegions = '/campaign/:id/guarantor/region/active';
export const campaignGuarantorActiveRegion = '/campaign/:id/guarantor/region/:regionId/active';
export const campaignGuarantorRegionGuarantor = '/campaign/:id/guarantor/region/:regionId/guarantor';
export const campaignStatus = '/campaign/:id/status';
export const campaignReset = '/campaign/:id/reset';
export const campaignStartupCurve = '/campaign/:id/startup-curve';
export const campaignNominations = '/campaign/:id/nominations';
export const campaignNominationsCount = '/campaign/:id/nominations-count';
export const campaignPattern = '/campaign/pattern';
export const campaignPatternDelete = '/campaign/pattern/:id';
export const campaignPatternList = '/campaign/pattern/list';
export const campaignLoadPattern = '/campaign/pattern/:id/campaign/:campaignId';
export const campaignOrder = '/campaign/:id/contact-orders';
export const campaignReport = '/campaign/report';
export const solutionStateList = `/code-table/${codelists.solutionState}`;
// Campaign contacts
export const contactAdditionalData = '/contact/:id/additional-data';
export const contactList = '/contact/list';
export const contactStateCount = '/contact/state-count';
export const contactDetail = '/contact/:id';
export const contactDetailComment = '/contact/:id/comment';
export const contactAssignAll = '/contact/assign-all';
export const contactReleaseContact = '/contact/release-contact';
export const contactReleaseAll = '/contact/release-all';
export const contactSetPrintType = '/contact/set-print-type';
export const contactSetPrintAll = '/contact/set-print-all';
export const contactManualAssignContactList = '/contact/manual-assign-contact-list';
export const contactAutoAssignContactList = '/contact/auto-assign-contact-list';
export const checkContactProcessing = '/contact/check-contact-processing';
// Dashboards
export const dashboardCentralSummary = '/dashboard/central-summary';
export const dashboardManagerSummary = '/dashboard/manager-summary';
export const dashboardManagersOfRegion = '/dashboard/managers-of-region';
export const dashboardPpzSummary = '/dashboard/ppz-summary';
export const dashboardPpzsOfSeller = '/dashboard/ppzs-of-seller';
export const dashboardRegionSummary = '/dashboard/region-summary';
export const dashboardRegionsOfCampaign = '/dashboard/regions-of-campaign';
export const dashboardReport = '/dashboard/report';
export const dashboardSellerSummary = '/dashboard/seller-summary';
export const dashboardSellersOfManager = '/dashboard/sellers-of-manager';
// Partner and Policy (PK)
export const policy = '/policy';
export const policyList = '/policy/list';
export const policyListExport = '/policy/list-export';
export const partnerList = '/partner/list';
export const partner = '/partner/:id';
// Contact History
export const communicationHistory = '/communication/history';
export const communicationHistoryExport = '/communication/history-export';
// Production operations
export const production = '/production';
export const productionBruttoList = '/production/brutto/list';
export const productionDocuments = '/production/documents';
export const productionDocumentsDelete = '/production/delete-documents';
export const productionDocument = '/production/document';
export const productionReport = '/production/report';
export const productionClose = '/production/close';
export const productionImport = '/production/import-ccd-policies';
export const tiaPoliciesLoad = '/production/get-ccd-policies';
export const hasInvalidProduction = '/production/has-invalid';
// Inter application context operations
export const ispProvision = '/iasc/isp-provision';
export const kHDetail = '/iasc/kh-detail';
export const lindenDetail = '/iasc/linden-detail';
export const pKPartner = '/iasc/pk-partner';
export const pKPolicy = '/iasc/pk-policy';
export const pKPartnerUnlock = '/iasc/pk-partner-unlock';
export const pKPolicyUnlock = '/iasc/pk-policy-unlock';
export const golpContactLink = '/iasc/golp-contact';
export const greqContactLink = '/iasc/greq-contact';
export const greqContact133Link = '/iasc/greq-contact-133';
export const greqTaskPartnerLink = '/iasc/greq-task-partner';
// Unlocked clients
export const unlockedClientsList = '/partner/unlock/list';
// Leads - market place
export const createLead = '/lead';
export const leadsList = '/lead/list';
export const finishLead = '/lead/:id/finish';
export const takeLead = '/lead/:id/redirect';
export const leadNote = '/lead/:id/note';
export const leadOverview = '/lead/overview';
export const competitionAvailableLeads = '/lead/competition-list';
export const leadDetail = '/lead/:id';
export const returnLead = '/lead/:id/return';
export const leadOpen = '/lead/:id/open';

// Production Control
export const koprMyDocuments = '/document-check/my-documents';
export const koprDocumentsToReview = '/document-check/statement-documents';
export const koprRegion = '/document-check/filter/regions';
export const koprSuperiors = '/document-check/filter/superiors-of-wave-and-region';
export const koprSubordinates = '/document-check/filter/solvers-of-wave-and-superior';
export const koprClientsDocumentsToReview = '/document-check/filter/clients-of-statement-documents';
export const koprClientsMyDocuments = '/document-check/filter/clients-of-my-documents';
export const koprDetail = '/document-check/document/:documentId/detail';
export const koprDetailNotices = '/document-check/document/:documentId/notices';
export const koprNewNotice = '/document-check/document/notice';
export const koprDocumentsCheckWaves = '/document-check/filter/waves';
export const koprReport = '/document-check/report';

// Dashboard - entry page
export const unpayedFirstPayment = '/entry-page/policy/un-payed-first-payment/:productDomain/count';
export const leadsInProgress = '/entry-page/lead/un-finished/count';
export const takenOrInProgressLeads = '/entry-page/lead/from-market';
export const availableLeads = '/entry-page/lead/marketplace';
export const campaignsSummary = '/entry-page/campaign/summary';
export const campaignContactsSummary = '/entry-page/contact/summary';
export const tasksAndInformation = '/entry-page/task/overview';
export const leadsOverview = '/entry-page/lead/not-from-market';

// Dashboard - entry page manager
export const escalationBasic = '/entry-page-manager/escalation/basic';
export const escalationSummary = '/entry-page-manager/escalation/summary';
export const campaignsNearingTheEndManager = '/entry-page-manager/campaigns/ending';
export const campaignsNearingTheEndContactRelease = '/entry-page-manager/contacts/state/process';
export const leadsToProcess = '/entry-page-manager/leads/state/process';
export const myTeamSummary = '/entry-page-manager/subordinates/summary';
export const bruttoProduction = '/entry-page-manager/subordinates/brutto-production';
export const statisticsTasksSummary = '/entry-page-manager/tasks/summary';
export const leadsSummary = '/entry-page-manager/leads/summary';
export const contactsSummary = '/entry-page-manager/contacts/summary';
export const productionSummary = '/entry-page-manager/contacts/production';
export const campaignManagementSummary = '/entry-page-manager/campaigns-management/summary';
export const campaignManagementContacts = '/entry-page-manager/campaigns-management/summary/contacts';

// San Marco
export const unfinishedTaskReport = '/ext/san-marco/unfinished-task-report';
// Robo Advisory
export const raList = '/ra/list';
export const raHandover = '/ra/redirect';
// Semaphore
export const semaphoreList = '/semaphore/list';
export const semaphoreDashboard = '/semaphore/dashboard';
export const semaphoreSaveFeedbackValue = '/semaphore/feedback/value';
export const semaphoreSaveFeedbackNote = '/semaphore/feedback/note';
// Navbar - clear user's cache
export const clearUsersCache = '/application/clear-user-cache';
// Upload
export const finishTaskAttachment = '/upload/finish-task-attachment/:id';
export const createTaskAttachment = '/upload/create-task-attachment/:id';
export const checkTaskAttachment = '/upload/create-task-attachment/check-document?';

// settings
export const settingsAllowedRegionsAndSegments = '/settings/allowed/regions-segments';
export const settingsMarketPlaceAgencies = '/settings/managers/region/:regionId/segment/:segmentId';
export const settingsMarketPlaceAgencyManagersAndSubordinates =
	'/settings/managers/region/:regionId/segment/:segmentId/area/:areaId?';
export const settingsMarketPlaceAgenciesSearchUser = '/settings/managers/region/:regionId/search';
export const saveMarketPlaceAgenciesChanges = '/settings/update';

// TODO: madeup endpoint, change when BE ready
export const processTask = '/task/finish';
export const processAllTask = '/task/finish-all-tasks';
export const checkFinishAllProcessing = '/task/finish-all-tasks-status';
export const sendRequest = '/sendRequest';
